export default (function (_ref) {
  var service = _ref.service,
    request = _ref.request;
  return {
    getArticleList: function getArticleList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/article/get",
        method: "get",
        params: data
      });
    },
    getArticleInfo: function getArticleInfo() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/article/getInfo",
        method: "get",
        params: data
      });
    },
    addArticle: function addArticle() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/article/create",
        method: "post",
        data: data
      });
    },
    updateArticle: function updateArticle() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/article/update",
        method: "post",
        data: data
      });
    },
    deleteArticle: function deleteArticle() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/article/delete",
        method: "post",
        data: data
      });
    },
    setArticleStatus: function setArticleStatus() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/article/setStatus",
        method: "post",
        data: data
      });
    },
    setArticlePraise: function setArticlePraise() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/article/setPraiseNum",
        method: "post",
        data: data
      });
    },
    getArticleCommentList: function getArticleCommentList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/article/getCommentList",
        method: "get",
        params: data
      });
    },
    deleteArticleComment: function deleteArticleComment() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/article/deleteComment",
        method: "post",
        data: data
      });
    }
  };
});